"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Maybe =
/*#__PURE__*/
function () {
  function Maybe(value) {
    _classCallCheck(this, Maybe);

    this.value = value;
  }

  _createClass(Maybe, [{
    key: "isNothing",
    value: function isNothing() {
      return this.value === null || this.value === undefined;
    }
  }, {
    key: "map",
    value: function map(fn) {
      var newValue = this.isNothing() ? null : fn(this.value);
      return Maybe.of(newValue);
    }
  }, {
    key: "mapAll",
    value: function mapAll(fnList) {
      if ((0, _utils.isArray)(fnList)) {
        return fnList.reduce(function (prevValue, currVal) {
          return (0, _utils.isFunction)(currVal) ? prevValue.map(currVal) : prevValue;
        }, this);
      }

      if ((0, _utils.isFunction)(fnList)) {
        return this.map(fnList);
      }

      return this;
    }
  }, {
    key: "fold",
    value: function fold(falsyComponent, truthyComponent) {
      return this.isNothing() || this.value === false ? falsyComponent : truthyComponent;
    }
  }], [{
    key: "of",
    value: function of(value) {
      return new Maybe(value);
    }
  }]);

  return Maybe;
}();

var _default = Maybe;
exports.default = _default;